import React from "react";
import { Stack, Banner } from "@primer/react/experimental";
import { useAlert } from "../../context/alert";

const AlertBanner: React.FC = () => {
    const { alerts, removeAlert } = useAlert();

    if (alerts.length === 0) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999,
                maxWidth: '500px',
                width: '90%',
                pointerEvents: 'none',
            }}
        >
            <Stack direction="vertical" gap="condensed">
                {alerts.map((alert) => (
                    <div key={alert.id} style={{ pointerEvents: 'auto' }}>
                        {alert.isCustom && alert.customComponent ? (
                            <Stack align="center">
                                <alert.customComponent
                                    {...alert.customProps}
                                    onDismiss={() => removeAlert(alert.id)}
                                />
                            </Stack>
                        ) : (
                            <Banner
                                title={alert.title}
                                description={alert.description || alert.message}
                                hideTitle={alert.hideTitle ?? true}
                                icon={alert.icon}
                                variant={alert.variant}
                                primaryAction={alert.primaryAction}
                                secondaryAction={alert.secondaryAction}
                                onDismiss={() => removeAlert(alert.id)}
                            />
                        )}
                    </div>
                ))}
            </Stack>
        </div>
    );
};

export default AlertBanner;